import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAdminAuthenticated } from "../api/adminSession";

/**
 * Route guard for admin-only pages. Anyone who is not a signed-in company
 * admin — including ordinary logged-in users — is sent to the admin sign-in
 * page. This only hides the UI; the API enforces the same rule itself.
 */
export default function RequireAdmin({ children }) {
  const location = useLocation();

  if (!isAdminAuthenticated()) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
